import { useStore } from "../../store";
import { Plaque } from "./Plaque";

const MAX_MIRRORED_MESSAGES = 8;
const MAX_LINE_CHARS = 36;

/**
 * Diegetic mirror of the DOM ChatPanel. Reads the same zustand chatLog
 * (capped to last N messages) and renders them on a wall board. The DOM panel
 * at bottom-left stays — chat lives in both places by design.
 */

interface ChatMirrorBoardProps {
  position: [number, number, number];
  rotation?: [number, number, number];
}

export function ChatMirrorBoard({
  position,
  rotation,
}: ChatMirrorBoardProps): JSX.Element {
  const log = useStore((s) => s.chatLog);
  const recent = log.slice(-MAX_MIRRORED_MESSAGES);
  const lines =
    recent.length === 0
      ? ["(no messages yet)"]
      : recent.map((m) => truncate(`${m.from}: ${m.body}`, MAX_LINE_CHARS));

  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={4.0}
      height={2.8}
      backerColor="#171a26"
      title="LOBBY CHAT"
      titleColor="#8bb6ff"
      titleSize={0.22}
      lines={lines}
      bodyColor="#e8e8ef"
      bodySize={0.18}
      align="left"
    />
  );
}

function truncate(s: string, n: number): string {
  if (s.length <= n) return s;
  return s.slice(0, n - 1) + "…";
}
